import { useState, useContext } from "react";
import { Box, Paper, Typography, TextField, Button, IconButton, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { ColorModeContext } from "../ThemeContext";
import { resetPassword } from "../api/api";

export default function ResetPassword() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);

  const isDark = theme.palette.mode === "dark";
  const paperBg = isDark ? "#23272f" : "#fff";
  const textColor = isDark ? "#fff" : "#23272f";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);
    try {
      await resetPassword(email, code, newPassword);
      setMsg("Senha redefinida com sucesso! Redirecionando para login...");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      setMsg(
        err.response?.data?.error ||
        "Erro ao redefinir senha. Verifique o código e tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Paper
        sx={{
          p: { xs: 3, sm: 4 },
          width: { xs: 320, sm: 370 },
          maxWidth: "95vw",
          borderRadius: 4,
          bgcolor: paperBg,
          color: textColor,
          position: "relative",
          boxShadow: 6,
        }}
      >
        <IconButton
          size="small"
          onClick={colorMode.toggleColorMode}
          sx={{ position: "absolute", top: 13, right: 13 }}
        >
          {isDark ? <Brightness7 /> : <Brightness4 />}
        </IconButton>
        <Typography variant="h5" gutterBottom align="center" sx={{ fontWeight: 700 }}>
          Redefinir senha
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="E-mail"
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            type="email"
            autoComplete="email"
          />
          <TextField
            fullWidth
            label="Código recebido"
            margin="normal"
            value={code}
            onChange={e => setCode(e.target.value)}
            required
            autoComplete="one-time-code"
          />
          <TextField
            fullWidth
            label="Nova senha"
            margin="normal"
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 2, fontWeight: 600 }}
            disabled={loading}
          >
            Redefinir senha
          </Button>
        </form>
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          <Link to="/login" style={{ color: theme.palette.primary.main, fontWeight: 500 }}>
            Voltar ao login
          </Link>
        </Typography>
        {msg && <Alert severity={msg.startsWith("Senha redefinida") ? "success" : "error"} sx={{ mt: 2, textAlign: "center" }}>{msg}</Alert>}
      </Paper>
    </Box>
  );
}

